import { parseApiDate } from 'affiny-core/helpers/date';
import { IMessage } from 'affiny-core/modules/messages/types';
import { IRootState } from 'affiny-core/modules/state';
import orderBy from 'lodash/orderBy';

export const selectMessage = (state: IRootState, id: string): IMessage =>
  state.messages.entries[id];

export const selectLastMessage = (
  state: IRootState,
  ids: string[]
): IMessage => {
  const orderedMsgs = orderBy(
    ids.map(id => selectMessage(state, id)),
    ({ attributes: { sentAt } }: IMessage) => parseApiDate(sentAt),
    ['desc']
  );

  return orderedMsgs[0];
};
